import React from 'react';

export const AnalyzeAnomalyCases = () => <h1 className="pageTitle">Anomaly Cases</h1>;
